import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchInbox = createAction(constants.FETCH_INBOX)
export const fetchInboxPending = createAction(constants.FETCH_INBOX_PENDING)
export const fetchInboxCancelled = createAction(constants.FETCH_INBOX_CANCELLED)
export const fetchInboxFailed = createAction(constants.FETCH_INBOX_FAILED)
export const receiveInbox = createAction(constants.RECEIVE_INBOX)

export const bulkCloseForInbox = createAction(constants.BULK_CLOSE_FOR_INBOX)
export const bulkCloseForInboxRequested = createAction(constants.BULK_CLOSE_FOR_INBOX_REQUESTED)
export const bulkCloseForInboxFailed = createAction(constants.BULK_CLOSE_FOR_INBOX_FAILED)

export const fetchInboxList = createAction(constants.FETCH_INBOX_LIST)
export const fetchInboxListPending = createAction(constants.FETCH_INBOX_LIST_PENDING)
export const fetchInboxListCancelled = createAction(constants.FETCH_INBOX_LIST_CANCELLED)
export const fetchInboxListFailed = createAction(constants.FETCH_INBOX_LIST_FAILED)
export const receiveInboxList = createAction(constants.RECEIVE_INBOX_LIST)

export const fetchCountsForInboxIds = createAction(constants.FETCH_COUNTS_FOR_INBOX_IDS)
export const fetchCounts = createAction(constants.FETCH_COUNTS)
export const fetchCountsPending = createAction(constants.FETCH_COUNTS_PENDING)
export const fetchCountsCancelled = createAction(constants.FETCH_COUNTS_CANCELLED)
export const fetchCountsFailed = createAction(constants.FETCH_COUNTS_FAILED)
export const receiveCounts = createAction(constants.RECEIVE_COUNTS)
export const receiveCounts2 = createAction(constants.RECEIVE_COUNTS_2)
export const changeStatus = createAction(constants.CHANGE_STATUS)
export const bulkChangeStatus = createAction(constants.BULK_CHANGE_STATUS)
export const changeParticipants = createAction(constants.CHANGE_PARTICIPANTS)

export const inboxChanged = createAction(constants.INBOX_CHANGED)
export const inboxRedirect = createAction(constants.INBOX_REDIRECT)

export const fetchWhitelabel = createAction(constants.FETCH_WHITELABEL)
export const fetchWhitelabelPending = createAction(constants.FETCH_WHITELABEL_PENDING)
export const fetchWhitelabelFailed = createAction(constants.FETCH_WHITELABEL_FAILED)
export const fetchWhitelabelCancelled = createAction(constants.FETCH_WHITELABEL_CANCELLED)
export const fetchWhitelabelSuccess = createAction(constants.FETCH_WHITELABEL_SUCCESS)

export const createInboxBeforeWhitelabel = createAction(constants.CREATE_INBOX_BEFORE_WHITELABEL)
export const createWhitelabel = createAction(constants.CREATE_WHITELABEL)
export const createWhitelabelPending = createAction(constants.CREATE_WHITELABEL_PENDING)
export const createWhitelabelFailed = createAction(constants.CREATE_WHITELABEL_FAILED)
export const createWhitelabelCancelled = createAction(constants.CREATE_WHITELABEL_CANCELLED)
export const createWhitelabelSuccess = createAction(constants.CREATE_WHITELABEL_SUCCESS)

export const verifyWhitelabel = createAction(constants.VERIFY_WHITELABEL)
export const verifyWhitelabelPending = createAction(constants.VERIFY_WHITELABEL_PENDING)
export const verifyWhitelabelFailed = createAction(constants.VERIFY_WHITELABEL_FAILED)
export const verifyWhitelabelCancelled = createAction(constants.VERIFY_WHITELABEL_CANCELLED)
export const verifyWhitelabelSuccess = createAction(constants.VERIFY_WHITELABEL_SUCCESS)

export const openWhitelabelDKIMSetting = createAction(constants.OPEN_WHITELABEL_DKIM_SETTING)
export const closeWhitelabelDKIMSetting = createAction(constants.CLOSE_WHITELABEL_DKIM_SETTING)

export const createInbox = createAction(constants.CREATE_INBOX)
export const createInboxPending = createAction(constants.CREATE_INBOX_PENDING)
export const createInboxFailed = createAction(constants.CREATE_INBOX_FAILED)
export const createInboxCancelled = createAction(constants.CREATE_INBOX_CANCELLED)
export const createInboxSuccess = createAction(constants.CREATE_INBOX_SUCCESS)

export const patchInbox = createAction(constants.PATCH_INBOX)
export const patchInboxPending = createAction(constants.PATCH_INBOX_PENDING)
export const patchInboxFailed = createAction(constants.PATCH_INBOX_FAILED)
export const patchInboxSuccess = createAction(constants.PATCH_INBOX_SUCCESS)

export const archiveInbox = createAction(constants.ARCHIVE_INBOX)
export const archiveInboxPending = createAction(constants.ARCHIVE_INBOX_PENDING)
export const archiveInboxFailed = createAction(constants.ARCHIVE_INBOX_FAILED)
export const archiveInboxSuccess = createAction(constants.ARCHIVE_INBOX_SUCCESS)


export const fetchSendingDomains = createAction(constants.FETCH_SENDING_DOMAINS)
export const fetchSendingDomainsPending = createAction(constants.FETCH_SENDING_DOMAINS_PENDING)
export const fetchSendingDomainsFailed = createAction(constants.FETCH_SENDING_DOMAINS_FAILED)
export const fetchSendingDomainsSuccess = createAction(constants.FETCH_SENDING_DOMAINS_SUCCESS)

export const createSendingDomain = createAction(constants.CREATE_SENDING_DOMAIN)
export const createSendingDomainPending = createAction(constants.CREATE_SENDING_DOMAIN_PENDING)
export const createSendingDomainFailed = createAction(constants.CREATE_SENDING_DOMAIN_FAILED)
export const createSendingDomainFailedNoUser = createAction(constants.CREATE_SENDING_DOMAIN_FAILED_NO_USER)
export const createSendingDomainSuccess = createAction(constants.CREATE_SENDING_DOMAIN_SUCCESS)

export const verifySendingDomain = createAction(constants.VERIFY_SENDING_DOMAIN)
export const verifySendingDomainPending = createAction(constants.VERIFY_SENDING_DOMAIN_PENDING)
export const verifySendingDomainFailed = createAction(constants.VERIFY_SENDING_DOMAIN_FAILED)
export const verifySendingDomainSuccess = createAction(constants.VERIFY_SENDING_DOMAIN_SUCCESS)

export const deleteSendingDomain = createAction(constants.DELETE_SENDING_DOMAIN)
export const deleteSendingDomainPending = createAction(constants.DELETE_SENDING_DOMAIN_PENDING)
export const deleteSendingDomainFailed = createAction(constants.DELETE_SENDING_DOMAIN_FAILED)
export const deleteSendingDomainSuccess = createAction(constants.DELETE_SENDING_DOMAIN_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/inbox/actions.js